import { Dispatch, SetStateAction } from 'react';
import { css } from '@emotion/react';
import { BalanceType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { SwitchChipGroup, Text } from '@frontend/design-system';
import { useBulkCollectionsFilterShallowStore } from '../../../../store/bulk-collections-filter-store';

const styles = {
  container: css`
    .balance-type-chips-group.selected {
      background-color: ${theme.colors.primary10};
      color: ${theme.colors.white};
      border: solid 1px ${theme.colors.primary50};
    }
    .balance-type-chips-group {
      max-width: fit-content;
    }
  `,
};

export const FiltersOnDesktop = () => {
  const { t } = useTranslation('payments');
  const { balanceType, setBalanceType } = useBulkCollectionsFilterShallowStore('balanceType', 'setBalanceType');

  const allBalanceTypes = [
    BalanceType.BALANCE_TYPE_NEW,
    BalanceType.BALANCE_TYPE_UPDATE,
    BalanceType.BALANCE_TYPE_EXISTS,
  ];

  const handleSetValue: Dispatch<SetStateAction<string[]>> = (action) => {
    const newValues = typeof action === 'function' ? action(balanceType as string[]) : action;
    if (newValues.includes('all') || allBalanceTypes.every((type) => newValues.includes(type))) {
      setBalanceType([]);
    } else {
      setBalanceType(newValues as BalanceType[]);
    }
  };

  return (
    <SwitchChipGroup checkboxMode value={balanceType} setValue={handleSetValue} css={styles.container}>
      <SwitchChipGroup.Option
        value={'all'}
        className={`balance-type-chips-group ${balanceType.length === 0 ? 'selected' : ''}`}
        trackingId='balance-type-button-all'
      >
        <Text size='medium'>{t('All')}</Text>
      </SwitchChipGroup.Option>
      <SwitchChipGroup.Option
        value={BalanceType.BALANCE_TYPE_NEW}
        className={`balance-type-chips-group ${balanceType.includes(BalanceType.BALANCE_TYPE_NEW) ? 'selected' : ''}`}
        trackingId='balance-type-button-new'
      >
        <Text size='medium'>{t('New Balances')}</Text>
      </SwitchChipGroup.Option>
      <SwitchChipGroup.Option
        value={BalanceType.BALANCE_TYPE_UPDATE}
        className={`balance-type-chips-group ${
          balanceType.includes(BalanceType.BALANCE_TYPE_UPDATE) ? 'selected' : ''
        }`}
        trackingId='balance-type-button-changed'
      >
        <Text size='medium'>{t('Changed Balances')}</Text>
      </SwitchChipGroup.Option>
      <SwitchChipGroup.Option
        value={BalanceType.BALANCE_TYPE_EXISTS}
        className={`balance-type-chips-group ${
          balanceType.includes(BalanceType.BALANCE_TYPE_EXISTS) ? 'selected' : ''
        }`}
        trackingId='balance-type-button-outstanding'
      >
        <Text size='medium'>{t('Outstanding Balances')}</Text>
      </SwitchChipGroup.Option>
    </SwitchChipGroup>
  );
};
